/** Symmetric SVG chevron, centered by its viewBox rather than a font baseline. */
export const CarouselChevron = ({ direction }: { direction: 'left' | 'right' }) => (
  <svg
    aria-hidden="true"
    className="block h-[14px] w-[14px] flex-none"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d={direction === 'left' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6'}
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
